import { createExternalEventApi } from './external-event.api.websocket';
import { createSimpleStore } from '@passionware/simple-store';

export const websocketStore = createSimpleStore<any>(null);
export const myExternalEventApi = createExternalEventApi(websocketStore);
